class DismissibleLocalization extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    (function (window) {
      var Storage = function () {

        function browserSupport() {
          var testStorage = 'localStorageTest';
          if (window.localStorage) {
            try {
              window.localStorage.setItem(testStorage, testStorage);
              window.localStorage.removeItem(testStorage);
              return true;
            } catch (e) {
              return false;
            }
          }
        }

        function deleteItem(item) {
          return window.localStorage.removeItem(item);
        }

        function getItem(item) {
          return window.localStorage.getItem(item);
        }

        function setItem(item, contents) {
          return window.localStorage.setItem(item, contents);
        }

        return {
          delete: deleteItem,
          enabled: browserSupport,
          get: getItem,
          set: setItem
        }
      }

      window.Storage = new Storage();

    })(window);

    (function (window, Storage) {
      var storageEnabled = window.Storage.enabled();
      var dismissibleItem = function (el, id, value, expiry) {

        var hasExpiry = (id && expiry) ? true : false,
            html = value;

        if (hasExpiry && storageEnabled) {
          var timestamp = window.Storage.get(id);
          if (timestamp) {
            if (expiry === 'forever') {
              el.remove();
              return;
            } else {
              var now = new Date(),
                  diffInHours = Math.floor((now.getTime() - parseInt(timestamp)) / (1000 * 60 * 60));
              if (diffInHours >= expiry) {
                window.Storage.delete(id);
              } else {
                el.remove();
                return;
              }
            }
          }
        }

        el.removeAttribute('data-component');
        el.removeAttribute('data-expiry');
        el.removeAttribute('data-id');
        el.removeAttribute('data-value');
        el.innerHTML = html;

        function dismissBanner(event) {
          var height = el.offsetHeight,
              opacity = 1,
              timeout = null;

          if (hasExpiry && storageEnabled) {
            window.Storage.set(id, new Date().getTime());
          }

          function reduceHeight() {
            height -= 2;
            el.setAttribute('style', 'height: ' + height + 'px; opacity: ' + opacity);
            if (height <= 0) {
              window.clearInterval(timeout);
              timeout = null;
              el.remove();
            }
          }

          function fade() {
            opacity -= .1;
            el.setAttribute('style', 'opacity: ' + opacity);
            if (opacity <= 0) {
              window.clearInterval(timeout);
              timeout = window.setInterval(reduceHeight, 1);
            }
          }
          timeout = window.setInterval(fade, 25);
        }

        el.querySelector('.banner-close').addEventListener('click', dismissBanner);
      }

      var dismissibleComponents = Array.prototype.slice.call(document.querySelectorAll('[data-component="dismissible"]'));

      if (dismissibleComponents != null) {
        for (var i = 0; i < dismissibleComponents.length; i++) {
          var expiry = dismissibleComponents[i].getAttribute('data-expiry'),
              id = dismissibleComponents[i].getAttribute('data-id'),
              value = dismissibleComponents[i].getAttribute('data-value');
          new dismissibleItem(dismissibleComponents[i], id, value, expiry);
        }
      }

    })(window, Storage);
  }
}

customElements.define('dismissible-localization', DismissibleLocalization);
